import { useState } from "react";
import { router } from "@inertiajs/react";
import { Button } from "./ui/button";

interface CommentInputProps {
  commentableType: "TrackEvent" | "TrackEventGroup";
  commentableId: number;
  onCancel?: () => void;
  autoFocus?: boolean;
}

export function CommentInput({
  commentableType,
  commentableId,
  onCancel,
  autoFocus = false,
}: CommentInputProps) {
  const [body, setBody] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const basePath =
    commentableType === "TrackEvent"
      ? `/event/${commentableId}/comments`
      : `/event_group/${commentableId}/comments`;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!body.trim() || isSubmitting) return;

    setIsSubmitting(true);

    router.post(
      basePath,
      { comment: { body } },
      {
        preserveScroll: true,
        preserveState: false,
        onSuccess: () => {
          setBody("");
          onCancel?.();
        },
        onFinish: () => {
          setIsSubmitting(false);
        },
      }
    );
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex items-center gap-2">
        <input
          type="text"
          value={body}
          onChange={(e) => setBody(e.target.value)}
          placeholder="Add a comment..."
          className="flex-1 px-3 py-1.5 text-sm border border-neutral-200 rounded-md focus:outline-none focus:ring-1 focus:ring-neutral-300"
          autoFocus={autoFocus}
          disabled={isSubmitting}
        />
        <Button
          type="submit"
          size="sm"
          className="px-4 h-8"
          variant="secondary"
          disabled={isSubmitting || !body.trim()}
        >
          {isSubmitting ? "Posting..." : "Post"}
        </Button>
      </div>
    </form>
  );
}
